<template>
  <div>
    <el-dialog title="上传图片" append-to-body :modal-append-to-body="true" v-model="uploadModal"
     :width="isIframe ? '100%' : '800px'" :fullscreen="isIframe" @close="handleClosed" top="5vh">
      <div class="main" v-loading="loading">
        <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef" label-width="100px" class="demo-ruleForm">
          <el-form-item label="上传方式：" prop="type">
            <el-radio-group v-model="ruleForm.type" @change="handleRadioChange(ruleForm.type)">
              <el-radio :value="0">本地上传</el-radio>
              <el-radio :value="1">网络上传</el-radio>
              <el-radio :value="2">扫码上传</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传至分组：" prop="region" v-show="ruleForm.type == 0 || ruleForm.type == 1">
            <el-cascader class="form-width" v-model="ruleForm.region" :props="cascaderProps" :options="categoryList"
             @change="handleCascaderChange"></el-cascader>
          </el-form-item>
          <el-form-item label="网络图片：" prop="region" v-if="ruleForm.type == 1">
            <el-input class="form-width" v-model="webImgUrl" placeholder="请填写网络图片地址"></el-input>
            <span class="tq-text" @click="handleGetImg">提取照片</span>
          </el-form-item>
          <el-form-item label="上传图片：" prop="region" v-if="ruleForm.type == 0">
            <div class="acea-row">
              <div class="uploadCont">
                <el-upload ref="uploadRef" :action="fileUrl" list-type="picture-card" :on-change="handleFileChange"
                  :file-list="ruleForm.imgList" :auto-upload="false" :data="uploadData" :headers="myHeaders"
                 :before-upload="handleBeforeUpload" :multiple="true" :limit="limit">
                  <template #default>
<!--                   <i class="el-icon-plus"></i>-->

                      <el-icon><Plus /></el-icon>
                  </template>

                  <template #file="{ file }">
                    <!-- 根节点必须始终存在。网络图没有 name，v-if 为假时插槽会交出 null，上传列表更新就会报 vnode.type -->
                    <div
                     draggable="false" @dragstart="(e) => handleDragStart(e, file)"
                      @dragover="(e) => handleDragOver(e, file)" @dragenter="(e) => handleDragEnter(e, file)"
                      @dragend="(e) => handleDragEnd(e, file)">
                      <!-- {{['png','jpg','gif','jepg','svg'].indexOf(file.name.substr(file.name.lastIndexOf('.')+1))}} -->
                      <template v-if="isUploadThumb(file)">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
<!--                     <i class="el-icon-error btndel" @click="handleWebRemove(file)" ><CircleClose /></i>-->
                        <el-icon class=" el-icon-error btndel" @click.stop="handleWebRemove(file)"><CircleClose /></el-icon>
                      </template>
                    </div>
                  </template>
                </el-upload>
                <div class="tips">一次最多上传50张，建议上传图片最大宽度750px，不超过5MB；仅支持jpeg、png格式，可拖拽调整上传顺序</div>
              </div>
            </div>
          </el-form-item>
          <template v-if="ruleForm.type == 1">
            <div class="img-box pl100">
              <div v-for="(item, index) in ruleForm.imgList" :key="index" class="pictrue" draggable="false"
               @dragstart="(e) => handleDragStart(e, item)" @dragover.prevent="(e) => handleDragOver(e, item)"
                @dragenter="(e) => handleDragEnter(e, item)" @dragend="(e) => handleDragEnd(e, item)">
                <img :src="item.url" alt="" />
<!--               <i class="el-icon-error btndel" @click="handleRemove(index)" />-->
                  <el-icon class=" el-icon-error btndel" @click="handleRemove(index)"><CircleClose /></el-icon>
              </div>
            </div>
          </template>
          <div class="code-image" v-if="ruleForm.type == 2">
            <div class="left">
              <el-form-item label="上传至分组：" prop="region">
                <el-cascader class="form-width" v-model="ruleForm.region" :props="cascaderProps" :options="categoryList"
                 @change="handleCascaderChange"></el-cascader>
              </el-form-item>
              <el-form-item label="二维码：" prop="region">
                <div class="code">
                  <QRCodeVue3 v-if="qrcodeUrl" :value="qrcodeUrl" :size="160" level="H" render-as="svg" />
                  <div v-else style="padding: 20px; text-align: center; color: #999;">
                    等待生成二维码...
                  </div>
                </div>
                <div class="trip">扫描二维码，快速上传手机图片</div>
                <div class="trip-small">建议使用手机浏览器</div>
              </el-form-item>
            </div>
            <div class="right">
              <el-button size="small" @click="handleScanUploadGet">刷新图库</el-button>
              <div class="tip">刷新图库按钮，可显示移动端上传成功的图片</div>
              <div class="img-box">
                <div v-for="(item, index) in ruleForm.imgList" :key="index" class="pictrue" draggable="false"
                 @dragstart="(e) => handleDragStart(e, item)" @dragover.prevent="(e) => handleDragOver(e, item)"
                  @dragenter="(e) => handleDragEnter(e, item)" @dragend="(e) => handleDragEnd(e, item)">
                  <img :src="item.attachmentSrc" alt="" />
                  <!-- <i class="el-icon-error btndel" @click="handleWebRemove(item)" /> -->
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClear">取 消</el-button>
          <el-button type="primary" @click="handleSubmitUpload">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import { ref, reactive, watch, onMounted, onBeforeUnmount, getCurrentInstance, ComponentInternalInstance } from 'vue'
import { ElMessage } from 'element-plus';
import { getToken } from '@/utils/auth';
import { fileUpload, scanUploadQrcode, scanUploadGet, onlineUpload, scanUploadSave } from '@/api/setting'
import QRCodeVue3 from 'qrcode.vue'
import compressImg from '@/utils/compressImg';
import SettingMer from "@/libs/settingMer";

// 类型定义
interface CategoryItem {
  attachmentCategoryId: number
  attachmentCategoryName: string
  children?: CategoryItem[]
}

interface ImageItem {
  url: string
  raw?: File
  attachmentId?: number
  attachmentSrc?: string
}

interface RuleForm {
  type: number
  region: number
  imgList: ImageItem[]
}

interface UploadData {
  pid?: number
}

// Props
interface Props {
  categoryList?: CategoryItem[]
  categoryId?: string | number
  isPage?: boolean
  isIframe?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  categoryList: () => [],
  categoryId: '',
  isPage: false,
  isIframe: false
})

// Emits
const emit = defineEmits<{
 uploadSuccess: []
}>()

// 获取当前实例
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

// 响应式数据
const webImgUrl = ref<string>('')
const uploadModal = ref<boolean>(false)
const fileUrl = ref<string>(SettingMer.https + `/upload/image/0/file`)
const myHeaders = ref({ Authorization: 'Bearer ' + getToken() });
const uploadData = ref<UploadData>({})
const cascaderProps = reactive({
  checkStrictly: true,
  emitPath: false,
  label: 'attachmentCategoryName',
  value: 'attachmentCategoryId'
})
const disabled = ref<boolean>(false)
const ruleForm = reactive<RuleForm>({
  type: 0,
  region: 0,
  imgList: [],
})
const rules = reactive({
  type: [{ required: true, message: '请选择活动资源', trigger: 'change' }]
})
const qrcodeUrl = ref<string>('')
const scanToken = ref<string>('')
const limit = ref<number>(50)
const loading = ref<boolean>(false)
const time = ref<NodeJS.Timeout | undefined>(undefined)
const dragging = ref<any>(null)

// Refs
const ruleFormRef = ref()
const uploadRef = ref()

// 监听器
watch(uploadModal, (newVal) => {
  if (newVal) ruleForm.region = props.categoryId as number
}, { immediate: true })

// 生命周期
onMounted(() => {
  // 组件挂载后的逻辑
})

onBeforeUnmount(() => {
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
})

function isUploadThumb(file: { name?: string }) {
  const name = file?.name || ''
  if (!name) return false
  const ext = name.substr(name.lastIndexOf('.') + 1)
  return ['png', 'jpg', 'gif', 'jepg', 'svg'].indexOf(ext) !== -1
}

// EP radio 的 change 在 nextTick 才发出，v-model 会先渲染。
// 网络图只有 url、没有 name，本地上传列表会把空节点交进 TransitionGroup
watch(
  () => ruleForm.type,
  () => {
    ruleForm.imgList = []
  },
)

// 方法
const handleRadioChange = (type: number) => {
  ruleForm.type = type
  ruleForm.imgList = []
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
  if (type === 2) {
    handleScanUploadQrcode()
    time.value = setInterval(() => {
      handleScanUploadGet()
    }, 2000)
  }
}

const handleScanUploadQrcode = () => {
  scanUploadQrcode(ruleForm.region).then((res) => {
    handleCreateQrCode(res.data.url)
    scanToken.value = res.data.url
  }).catch((error) => {
    console.error('Failed to get QR code:', error)
    ElMessage.error('获取二维码失败')
  })
}

const handleScanUploadGet = () => {
  const token = scanToken.value.split('token=')[1]
  if (token) {
    scanUploadGet(token).then((res) => {
      ruleForm.imgList = res.data || []
    })
  }
}

const handleGetImg = () => {
  if (!webImgUrl.value) {
    ElMessage.error('请先输入图片地址')
    return
  }
  ruleForm.imgList.push({
    url: webImgUrl.value,
  })
}

const handleSubmitUpload = async () => {
  if (ruleForm.imgList.length <= 0) {
    return ElMessage.error('请上传图片')
  }

  if (ruleForm.type === 0) {
    uploadData.value = {
      pid: ruleForm.region,
    }
    if (ruleForm.imgList.length) {
      if (loading.value) return
      loading.value = true
      for (let i = 0; i < ruleForm.imgList.length; i++) {
        const file = ruleForm.imgList[i].raw
        if (file) {
          await handleUploadItem(file)
        }
        if (i === ruleForm.imgList.length - 1) {
          ElMessage.success('上传成功')
          emit('uploadSuccess')
          uploadModal.value = false
          loading.value = false
          handleInitData()
        }
      }
    }
  } else if (ruleForm.type === 1) {
   const urls = ruleForm.imgList.map((e) => e.url)
    if (urls.length) {
      if (loading.value) return
      loading.value = true
      onlineUpload({ id: ruleForm.region, images: urls })
        .then(() => {
          ElMessage.success('上传成功')
          emit('uploadSuccess')
          uploadModal.value = false
          loading.value = false
          handleInitData()
        })
        .catch((err) => {
          loading.value = false
          ElMessage.error(err.message)
        })
    }
  } else if (ruleForm.type === 2) {
    const token = scanToken.value.split('token=')[1]
    const attId = ruleForm.imgList.map((e) => e.attachmentId)
    scanUploadSave(token, { pid: ruleForm.region, ids: attId }).then((res) => {
      ElMessage.success(res.data?.message || '操作成功')
      emit('uploadSuccess')
      uploadModal.value = false
      handleInitData()
    })
  }
}

const handleUploadItem = (file: File): Promise<void> => {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('file', file)
    fileUpload(ruleForm.region, formData)
      .then((res) => {
        // console.log('handleUploadItem res',res)
        if (res.status === 200) {
          resolve()
        } else {
          loading.value = false
          ElMessage({
            message: '上传失败',
            type: 'error',
            duration: 1000,
          })
        }
      })
      .catch((err) => {
        loading.value = false
        ElMessage.error(err.message)
      })
  })
}

const handleBeforeUpload = (file: File) => {
  // 上传前的处理
}

const handleCreateQrCode = (url: string) => {
  qrcodeUrl.value = url
}

const handleWebRemove = (file: ImageItem & { uid?: number }) => {
  const index = ruleForm.imgList.findIndex((e) => {
    const item = e as ImageItem & { uid?: number }
    if (file.uid != null && item.uid != null) return item.uid === file.uid
    return e.url === file.url
  })
  if (index > -1) {
    ruleForm.imgList.splice(index, 1)
  }
  // 格式不符的文件只在 el-upload 内部列表，没进 imgList，按 url 删不到
  uploadRef.value?.handleRemove(file)
}

const handleRemove = (index: number) => {
  ruleForm.imgList.splice(index, 1)
}

const handleFileChange = async (file: any, fileList: any[]) => {
  const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp']
  if (allowedTypes.indexOf(file.raw?.type) === -1) {
    ElMessage.error('请上传正确的文件格式！')
    // el-upload 已把文件放进内部列表；未写入 imgList 时关闭按钮删不掉缩略图
    uploadRef.value?.handleRemove(file)
    return
  } else {
    if (file.size >= 2097152) {
      await handleCompressImg(file.raw).then(() => {
        fileList.forEach((e) => {
          // if (e.uid === file.uid) {
          //   e.raw = res;
          // }
        })
        ruleForm.imgList = fileList
      })
    } else {
      ruleForm.imgList = fileList
    }
  }
}

const handleCompressImg = (file: File): Promise<any> => {
  return new Promise((resolve, reject) => {
    compressImg(file).then((res) => {
      resolve(res)
    })
  })
}

const handleCascaderChange = (e: any) => {
  fileUrl.value = SettingMer.https + `/upload/image/${ruleForm.region}/file`
  if (ruleForm.type === 2) {
    handleScanUploadQrcode()
  }
}

// 拖拽相关方法
const handleDragStart = (e: DragEvent, item: any) => {
  dragging.value = item
}

const handleDragEnd = (e: DragEvent, item: any) => {
  dragging.value = null
}

const handleDragOver = (e: DragEvent, item?: any) => {
  if (e.dataTransfer) {
    e.dataTransfer.dropEffect = 'move'
  }
}

const handleDragEnter = (e: DragEvent, item: any) => {
  if (e.dataTransfer) {
    e.dataTransfer.effectAllowed = 'move'
  }
  if (item === dragging.value) {
    return
  }
  const newItems = [...ruleForm.imgList]
  const src = newItems.indexOf(dragging.value)
  const dst = newItems.indexOf(item)
  newItems.splice(dst, 0, ...newItems.splice(src, 1))
  ruleForm.imgList = newItems
}

const handleClosed = () => {
  handleInitData()
}

const handleClear = () => {
  uploadModal.value = false
  handleInitData()
}

const handleInitData = () => {
  ruleForm.type = 0
  ruleForm.region = 0
  scanToken.value = ''
  webImgUrl.value = ''
  ruleForm.imgList = []
  qrcodeUrl.value = ''
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
}

// 暴露给父组件的方法和属性
defineExpose({
  uploadModal
})




</script>
<style lang="scss" scoped>

.main {
  min-height: 400px
}

.pictrue {
  width: 64px;
  height: 64px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}

.btndel {
  position: absolute;
  z-index: 1;
  font-size: 18px;
  right: -5px;
  top: -5px;
  color: #999;
}

.form-width {
  width: 280px;
}

.tq-text {
  margin-left: 14px;
  font-size: 12px;
  font-weight: 400;
  color: var(--prev-color-primary);
  cursor: pointer;
}

:deep(.el-upload--picture-card),
:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 64px;
  height: 64px;
  line-height: 72px;
  overflow: inherit;
  border: none;
}

:deep(.el-upload--picture-card),
:deep(.el-upload-list--picture-card .el-upload-list__item img) {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px dotted rgba(0, 0, 0, 0.1);
}

.pl100 {
  padding-left: 100px;
}

.img-box {
  display: flex;
  flex-wrap: wrap;
}

.tips {
  font-size: 12px;
  color: #BBBBBB;
}

.code-image {
  display: flex;
  margin-top: 12px;

  .left {
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    align-items: center;

    .code {
      border: 1px solid #DDDDDD;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 200px;
      border-radius: 4px;

      .code-img {
        width: 160px;
        height: 160px;
      }
    }

    .form-width {
      width: 200px;
    }

    .code {
      margin-bottom: 14px;
    }

    .trip {
      color: #333333;
      text-align: center;
      line-height: 18px;
    }

    .trip-small {
      font-size: 12px;
      font-weight: 400;
      color: #BBBBBB;
      text-align: center;
      line-height: 16px;
    }
  }

  .right {
    margin-top: 62px;

    .tip {
      font-size: 12px;
      font-weight: 400;
      color: #BBBBBB;
      margin: 10px 0;
    }

  }
}
</style>
